import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';

import { Locations_delete_location_project_flowService } from './Locations.flow.index';

import { $types } from './Locations.types'

@Injectable({ providedIn: 'root' })
export class Locations_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
  }

    public Utilities: Utilities_FlowService;
  public Locations: Locations_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
  private _delete_location_project_flow: Locations_delete_location_project_flowService;
  public async delete_location_project_flow(inParams: { locationId: number, projectId: number }): Promise< { reason?: string }> {
    if(!this._delete_location_project_flow) {
      this._delete_location_project_flow = this.injector.get(Locations_delete_location_project_flowService);
    }
    return this._delete_location_project_flow.run(inParams);
  }
}
